import script from "./QuestionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionCard.vue?vue&type=script&setup=true&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=32234bfa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32234bfa"]])

export default __exports__